import React from "react";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const tableHead = ["Sr.No", "Name", "Mobile", "Email", "Actions"];

const MarketingTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const handleViewClient = (id) => {
    navigate(`/marketing/view-client/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{item?.fullName || "N/A"}</td>
                <td>{item?.mobileNumber || "N/A"}</td>
                <td>{item?.email || "N/A"}</td>
                <td>
                  <button
                    className="btn btn-sm px-3 btn-primary"
                    onClick={() => {
                      handleViewClient(item?.id);
                    }}
                  >
                    <BsArrowRightShort className="me-1" /> View
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MarketingTable;
